import { Reducer } from 'redux'
import { BlockchainNetwork } from '~/types'
import {
  BankAccount,
  AccountLimits,
  TransferInfo,
  ActionTypes,
  DEPOSIT_ACTIONS,
  BlockchainAddress,
  Account,
} from './types'

const initialState = {
  isLoading: false,
  isAddressLoading: false,
  bankAccounts: [],
  personalVerificationStatus: null,
  destination: undefined,
  destinationAmount: '',
  blockchainAddresses: [],
  selectedBlockchainNetwork: null,
  accountLimits: {
    holdingRemaining: '',
    holdingMax: '',
  },
  transferInfo: {
    recipientName: '',
    recipientBankName: '',
    recipientAccountNo: '',
    referenceNumber: '',
    expiredDate: '',
    depositAmount: '',
    userBankAccount: '',
    userHandPhoneNo: '',
  },
  accounts: {},
  isErc20Enabled: true,
  isZrc2Enabled: true,
  isZrc2NoticeBannerVisible: false,
  isErc20DepositFeeCharging: false,
  isZrc2DepositFeeCharging: false,
  isVAEnabled: false,
  isStraitsxUserDepositFlowInOneStep: false,
}

type State = {
  isLoading: boolean
  isAddressLoading: boolean
  bankAccounts: BankAccount[]
  personalVerificationStatus: string | null
  destination: number | undefined
  destinationAmount: string
  blockchainAddresses: BlockchainAddress[]
  selectedBlockchainNetwork: BlockchainNetwork | null
  accountLimits: AccountLimits
  transferInfo: TransferInfo
  accounts: { [key: string]: Account }
  isErc20Enabled: boolean
  isZrc2Enabled: boolean
  isZrc2NoticeBannerVisible: boolean
  isErc20DepositFeeCharging: boolean
  isZrc2DepositFeeCharging: boolean
  isVAEnabled: boolean
  isStraitsxUserDepositFlowInOneStep: boolean
}

export const deposit: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case DEPOSIT_ACTIONS.SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_ADDRESS_LOADING: {
      return {
        ...state,
        isAddressLoading: action.isAddressLoading,
      }
    }

    case DEPOSIT_ACTIONS.SET_BANK_ACCOUNTS: {
      return {
        ...state,
        bankAccounts: action.bankAccounts,
        isLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.SET_VERIFICATION_STATUS: {
      return {
        ...state,
        personalVerificationStatus: action.personalVerificationStatus,
      }
    }

    case DEPOSIT_ACTIONS.SET_DESTINATION: {
      return {
        ...state,
        destination: action.destination,
        destinationAmount: '',
      }
    }

    case DEPOSIT_ACTIONS.SET_DESTINATION_AMOUNT: {
      return {
        ...state,
        destinationAmount: action.destinationAmount,
      }
    }

    case DEPOSIT_ACTIONS.SET_BLOCKCHAIN_ADDRESSES: {
      return {
        ...state,
        blockchainAddresses: action.blockchainAddresses,
        isAddressLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.SET_SELECTED_BLOCKCHAIN_NEWTWORK: {
      return {
        ...state,
        selectedBlockchainNetwork: action.selectedBlockchainNetwork,
      }
    }

    case DEPOSIT_ACTIONS.GET_ACCOUNT_LIMITS: {
      return {
        ...state,
        accountLimits: action.accountLimits,
        isLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.CREATE_TOPUP_REQUEST: {
      return {
        ...state,
        transferInfo: action.transferInfo,
        isLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.SET_TRANSFER_INFO: {
      return {
        ...state,
        transferInfo: action.transferInfo,
        isLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.CREATE_BLOCKCHAIN_ADDRESS: {
      return {
        ...state,
        blockchainAddresses: [...state.blockchainAddresses, action.blockchainAddress],
        isLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.SET_ACCOUNTS: {
      return {
        ...state,
        accounts: action.accounts,
        isLoading: false,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_ERC20_ENABLED: {
      return {
        ...state,
        isErc20Enabled: action.isErc20Enabled,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_ZRC2_ENABLED: {
      return {
        ...state,
        isZrc2Enabled: action.isZrc2Enabled,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_ZRC2_NOTICE_BANNER_VISIBLE: {
      return {
        ...state,
        isZrc2NoticeBannerVisible: action.isZrc2NoticeBannerVisible,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_ERC20_DEPOSIT_FEE_CHARGING: {
      return {
        ...state,
        isErc20DepositFeeCharging: action.isErc20DepositFeeCharging,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_ZRC2_DEPOSIT_FEE_CHARGING: {
      return {
        ...state,
        isZrc2DepositFeeCharging: action.isZrc2DepositFeeCharging,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_VA_ENABLED: {
      return {
        ...state,
        isVAEnabled: action.isVAEnabled,
      }
    }

    case DEPOSIT_ACTIONS.SET_IS_STRAITSX_USER_DEPOSIT_FLOW_IN_ONE_STEP: {
      return {
        ...state,
        isStraitsxUserDepositFlowInOneStep: action.isStraitsxUserDepositFlowInOneStep,
      }
    }

    default:
      return state
  }
}
